import { exploreHomesGuard, guestPropertyGuard } from './_helpers/guest-property.guard';
import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { SignupComponent } from './auth/signup/signup.component';
import { OtpverificationComponent } from './auth/otpverification/otpverification.component';
import { PagenotfoundComponent } from './wildcard/pagenotfound/pagenotfound.component';
import { DashboardComponent } from './_components/dashboard/dashboard.component';
import { SearchComponent } from './_components/search/search.component';
import { ContactusComponent } from './_components/contactus/contactus.component';
import { AboutUsComponent } from './_components/about-us/about-us.component';
import { ThemesComponent } from './themes/themes.component';
import { ProfileComponent } from './_components/user/profile/profile.component';
import { TermsandconditionComponent } from './_components/termsandcondition/termsandcondition.component';
import { PrivacypolicyComponent } from './_components/privacypolicy/privacypolicy.component';
import { authGuard, noAuthGuard } from './_helpers/auth.guard';
import { PropertyViewComponent } from './_components/public/property-view/property-view.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ApprovalComponent } from './auth/approval/approval.component';
import { BasicuserviewComponent } from './_components/search/basicuserview/basicuserview.component';
import { PaymentComponent } from './_components/payment/payment.component';
import { BasicmobileviewComponent } from './_components/search/basicmobileview/basicmobileview.component';
import { CustomerPreferenceComponent } from './_components/search/customer-preference/customer-preference.component';
import { PaymentStatusComponent } from './_components/payment/payment-status/payment-status.component';
import { ReceiptFileComponent } from './_components/payment/receipt-file/receipt-file.component';
import { MismatchUserComponent } from './_components/public/property-view/mismatch-user/mismatch-user.component';
import { OptOutSubscribeComponent } from './_components/opt-out-subscribe/opt-out-subscribe.component';
import { ForNRIsComponent } from './_components/for-nris/for-nris.component';
import { PaymentPlanComponent } from './_components/payment-plan/payment-plan.component';

import { paymentEntryGuard } from './_helpers/payment.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./_components/cir-home/cir-home.component').then(m => m.CirHomeComponent),
    title: 'CircledPlus | Discover Exceptional Homes. Know Their Worth.',
  },
  { path: 'Cir_Home', redirectTo: '', pathMatch: 'full' },
  //open route
  {
    path: '',
    component: ThemesComponent,
    children: [
      { path: 'archive-home', component: DashboardComponent, data: { footer: 'default' } },
      { path: 'explore-homes', component: DashboardComponent, canActivate: [exploreHomesGuard] },
      { path: 'homes', canActivate: [guestPropertyGuard], loadComponent: () => import('./_components/public/homes/public-homes.component').then(m => m.PublicHomesComponent), data: { footer: 'default' } },
      { path: 'homes/:id', canActivate: [guestPropertyGuard], loadComponent: () => import('./_components/public/homes/public-homes.component').then(m => m.PublicHomesComponent), data: { footer: 'default', preview: true } },
      { path: 'search', component: SearchComponent,canActivate:[authGuard], data: { footer: 'alt' }},
      { path: 'basicuserview', component: BasicuserviewComponent,canActivate:[authGuard], data: { footer: 'alt' }},
      { path: 'basicmobileview', component: BasicmobileviewComponent,canActivate:[authGuard], data: { footer: 'alt' }},
      { path: 'profile', component: ProfileComponent,canActivate:[authGuard], data: { footer: 'default' }},
      { path: 'contactus', component: ContactusComponent, data: { footer: 'default' } },
      { path: 'aboutus', component: AboutUsComponent, data: { footer: 'default' } },
      { path: 'pricing', component: PaymentPlanComponent, canActivate: [paymentEntryGuard], data: { footer: 'default' } },
      { path: 'for-nri', component: ForNRIsComponent, data: { footer: 'default' } },
      { path: 'sharedPro/view/:name/:sheredToken', component: PropertyViewComponent,canActivate:[authGuard], data: { footer: 'alt' }},
      { path: 'termsandcondition', component: TermsandconditionComponent, data: { footer: 'default' } },
      { path: 'privacypolicy', component: PrivacypolicyComponent, data: { footer: 'default' } },
      { path: 'cnfrm-payment', component: PaymentComponent,canActivate:[paymentEntryGuard], data: { footer: 'default' } },
      { path: 'payment', component: PaymentPlanComponent, canActivate:[paymentEntryGuard], data: { footer: 'default' } },
      { path: 'pymnt-status', component: PaymentStatusComponent,canActivate:[authGuard], data: { footer: 'default' }},
      { path: 'customer-preference', component: CustomerPreferenceComponent, canActivate:[authGuard], data: { footer: 'default' } },
      { path: 'receipt-file', component: ReceiptFileComponent, canActivate: [authGuard], data: { footer: 'default' }},
      { path: 'mismatch-user', component: MismatchUserComponent, canActivate: [authGuard], data: { footer: 'default' }},
      { path: 'opt-out/:email', component: OptOutSubscribeComponent, data: { footer: 'default' } },
    ]
  },
  { path: 'login', component: LoginComponent, canActivate: [noAuthGuard], data: { hideSiteChrome: true } },
  { path: 'signup', component: SignupComponent, canActivate: [noAuthGuard], data: { hideSiteChrome: true } },
  { path: 'otp', component: OtpverificationComponent, canActivate: [noAuthGuard], data: { hideSiteChrome: true } },
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [noAuthGuard], data: { footer: 'default' } },
  { path: 'approval', component: ApprovalComponent, data: { footer: 'default' } },
  { path: '404', component: PagenotfoundComponent, data: { footer: 'default' } },
];
